import { yandexMap } from 'feature/addresses/redux/addressCreateSelector'
import { MarkIconType } from 'feature/YandexMap/types'
import { useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useLocation, useMatch } from 'react-router-dom'
import { useActions, useAppSelector } from 'store/hooks'

import { SearchServiceCenter } from './view/SearchServiceCenter'
import { ServiceCentersMainView } from './view/ServiceCentersMainView/ServiceCentersMainView'

// страница сц
export function ServiceCenters() {
  const methods = useForm({ defaultValues: { address: '' } })
  const servicePage = useAppSelector(state => state.services.servicePage)
  const { userGeo } = useAppSelector(yandexMap)
  const location = useLocation()

  const {
    setServicePage,
    setServiceListSearchText,
    setServiceTab,
    setGeolocationMarkCoords,
    setGeolocationMarkIcon,
    setCenter,
  } = useActions()

  // очищаю сохраненный данные для интерфейса,
  // если перешли не из детальной страницы
  useEffect(() => {
    if (location.state?.isServicePage) return

    setServiceListSearchText('')
    setServiceTab('map')
    setServicePage('services')
  }, [location, useMatch('*')])

  useEffect(() => {
    if (userGeo.coords && userGeo.coords[0] && userGeo.coords[1]) {
      setGeolocationMarkCoords(userGeo.coords)
      setCenter(userGeo.coords)
      setGeolocationMarkIcon(MarkIconType.geolocation)
    }
  }, [userGeo])

  const changePageType = (type: 'services' | 'address') => {
    setServicePage(type)
  }

  return (
    <>
      {servicePage === 'services' && (
        <ServiceCentersMainView setPageType={changePageType} />
      )}

      {servicePage === 'address' && (
        <FormProvider {...methods}>
          <SearchServiceCenter setPageType={changePageType} />
        </FormProvider>
      )}
    </>
  )
}
